import { ELinxSettingsResponse, PortalUser } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Direct-Pattern port of the portal's legacy tuple hook useFetchElinxSettings.
// No Success-throw: the Payment Methods tab only gates rendering on the
// response's presence, and the portal rendered the details pane even when the
// eLinx settings came back unsuccessful — keep that contract.
export default function useFetchElinxSettings() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [settings, setSettings] = useState<ELinxSettingsResponse>();

  async function fetchElinxSettings(params: PortalUser) {
    try {
      setFetching(true);

      const res = await api.fetchPaylinkSettings(params);

      setSettings(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, settings, fetchElinxSettings };
}
